$(function(){
  
  const ua = navigator.userAgent
  const isIOS = ua.indexOf("iPhone") >= 0
    || ua.indexOf("iPad") >= 0
    || navigator.userAgent.indexOf("iPod") >= 0;
  
  if(isIOS){
    $("meta[name='viewport']").attr("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0");
  }
  
  window.onpageshow = function(event) {
    if (event.persisted) {
      window.location.reload();
    }
  };

  // スクロールのドラッグ有効化
  jQuery.prototype.mousedragscrollable = function () {
    let target;
    $(this).each(function (i, e) {
      $(e).mousedown(function (event) {
        event.preventDefault();
        target = $(e);
        $(e).data({
          down: true,
          move: false,
          x: event.clientX,
          y: event.clientY,
          scrollleft: $(e).scrollLeft(),
          scrolltop: $(e).scrollTop(),
        });
        return false;
      });
      $(e).click(function (event) {
        if ($(e).data("move")) {
          return false;
        }
      });
    });
    $(document)
      .mousemove(function (event) {
        if ($(target).data("down")) {
          event.preventDefault();
          let move_x = $(target).data("x") - event.clientX;
          let move_y = $(target).data("y") - event.clientY;
          if (move_x !== 0 || move_y !== 0) {
            $(target).data("move", true);
          } else {
            return;
          }
          $(target).scrollLeft($(target).data("scrollleft") + move_x);
          $(target).scrollTop($(target).data("scrolltop") + move_y);
          return false;
        }
      })
      .mouseup(function (event) {
        $(target).data("down", false);
        return false;
      });
  };

  document.dispatchEvent(new 
  CustomEvent("swym:collections-loaded"));
  //横スクロール
  $.prototype.draggable = function() {
    var t;
    $(this).each(function(i,e) {
      $(e).mousedown(function(e2) {
        e2.preventDefault();
        t = $(e);
        $(e).data({
          down: true,
          x: e2.clientX,
          y: e2.clientY,
          left: $(e).scrollLeft(),
          top: $(e).scrollTop()
        });
      });
    });
    $(document).mousemove(function(e) {
      if($(t).data("down")) {
        e.preventDefault();
        $(t).scrollLeft($(t).data("x")+$(t).data("left")-e.clientX);
        $(t).scrollTop($(t).data("y")+$(t).data("top")-e.clientY);
      }
    }).mouseup(function(e) {
      $(t).data("down", false);
    });
  };
  
  if($('.shopify-section.featured-collection').length){
    //横スクロール
    $(".slider--desktop.slider--tablet").mousedragscrollable();
    
    var is_drag = 0;
    var target = $(".slider--desktop.slider--tablet");
  
    target.on('mousedown', function(e) {
      is_drag = 1;
        e.preventDefault();
      
    });
  
    target.on('mousemove', function() {
      is_drag = 0;
      if (!is_drag) {
        // $(this).addClass('drug');
        // .stopImmediatePropagation();
        // $(this).find('a').stopImmediatePropagation();
      }
      
    });
    target.on('mouseup', function() {
      target.click(function(){
        if (is_drag) {
          //click処理
        }else{
        $(this).addClass('drug');
        }
      });
        $(this).removeClass('drug');
    });
  }
  
  if($('#recently-viewed-products').length){
    $("#recently-viewed-products").mousedragscrollable();
  }
  
  if($('.shopify-section.section.related-products').length){
        
    window.addEventListener('DOMContentLoaded', function(){
    $("#related-products_box").mousedragscrollable();
    // $("#related-products_box ul").mousedragscrollable();
    // $("product-recommendations").mousedragscrollable();
    });
  }
});


window.addEventListener('load', function() {
  if($('.template_collection').length){
  }
  setTimeout(function() {
  if($('span[class*="boost-sd__filter-option-item-label 以上"]').length){
    $('span[class*="boost-sd__filter-option-item-label 以上"]').each(function(){
      var option_price = $(this).text().replace( '以上 ', '' );
      option_price = option_price.replace( option_price, option_price+' 以上' );
      $(this).text(option_price);
    });
  }

  }, 1000);
});
window.addEventListener('DOMContentLoaded', function(e){
  // if($('header.header').length){
  //   // 親要素を取得
  //   var moTarget_header = document.getElementById('cart-icon-bubble');
  
  //   // DOM操作時の動き
  //   function callback_header() {
  //     //処理
  //     if($('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').length){
  //       if($('#cart-icon-bubble_un .cart-count-bubble span[aria-hidden="true"]').length){
  //         $('#cart-icon-bubble_un .cart-count-bubble span[aria-hidden="true"]').text($('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').text()).show();
  //       }else{
  //         window.location.reload();
  //       }
  //     }else{
  //       $('#cart-icon-bubble_un .cart-count-bubble span[aria-hidden="true"]').hide();
  //     }
      
  //   }
  
  //   // MutationObserver登録・処理
  //   var mo_header = new MutationObserver(callback_header); 
    
  //   // 監視のオプション
  //   const moOption_header = {
  //     childList: true, //対象ノードの子ノードに対する追加・削除を監視
  //     subtree: true  //対象ノードとその子孫ノードも監視
  //   };
     
  //   // 監視対象とオプションを指定して observe() メソッドを実行（監視を開始）
  //   mo_header.observe(moTarget_header, moOption_header);
  // }
  if($('.template_cart').length){
    // $('cart-remove-button').click(function(e){
    //   setTimeout(function() {
    //     window.location.reload();
    //   }, 1000);
    // });
    $('cart-remove-button a').click(function(e){
      var product_id = $(this).attr('href');
      const before = "=";
      const after = ":";
      product_id = product_id.substr(0, product_id.indexOf(after));
      product_id = product_id.substr(product_id.indexOf(before) + 1);
      
      var input = false;
      var input_button = '';

      $('#is-a-gift li').each(function(){
        if($(this).find('input').hasClass('id_'+product_id) && $(this).find('input').is(':checked') ){
          input_button = $(this).find('input');
          // $(this).find('input').click();
          // $(this).find('input').prop('checked', false);
          input = true;
        }
      });

      if(input){
        input_button.click();
        return false;
        e.stopPropagation();
      }
      
      setTimeout(function() {
        window.location.reload();
      }, 1000);
    });
  }
  if($('.template_index').length){
    $('.wrapper.column_second').removeClass('load');
    // 親要素を取得
    var moTarget = document.getElementsByClassName('column_second')[0];
  
    // DOM操作時の動き
    function callback() {
      //処理
      $('aside').css({'margin-top':$('.shopify-section.Slider-section').outerHeight(true)+'px'});
      
      
      $(window).resize(function() {
        $('aside').css({'margin-top':$('.shopify-section.Slider-section').outerHeight(true)+'px'});
      });
      
    }
  
    // MutationObserver登録・処理
    var mo = new MutationObserver(callback); 
    
    // 監視のオプション
    const moOption = {
      childList: true, //対象ノードの子ノードに対する追加・削除を監視
      subtree: true  //対象ノードとその子孫ノードも監視
    };
     
    // 監視対象とオプションを指定して observe() メソッドを実行（監視を開始）
    mo.observe(moTarget, moOption);
  }

  if($('.template_page_terms_and_conditions.contact').length){
    $(document).on('click', 'a[href="/pages/receipt-sample"]', function() {
      $('div.receipt_modal').fadeToggle();
      return false;
    });
    $('div.receipt_modal').click(function() {
      $('div.receipt_modal').fadeToggle();
    });
  }
  if($('.template_customers_register').length){
    // // 親要素を取得
    // var moTarget = document.getElementsByClassName('cf-react-target')[0];
  
    // // DOM操作時の動き
    // function callback(mutationList, observer) {
    //   //処理
    //   for (const mutation of mutationList) {
    //     if (mutation.type === 'childList') {
    //       // $('.cf-verify-email-message').each(function(){
    //       //   var text = $(this).text();
    //       //   $(this).text(text.replace( '。', '。<br />' ));
    //       // });
    //     }
    //   }
      
    // }
  
    // // MutationObserver登録・処理
    // var mo = new MutationObserver(callback); 
    
    // // 監視のオプション
    // const moOption = {
    //   childList: true, //対象ノードの子ノードに対する追加・削除を監視
    //   subtree: true  //対象ノードとその子孫ノードも監視
    // };
     
    // // 監視対象とオプションを指定して observe() メソッドを実行（監視を開始）
    // mo.observe(moTarget, moOption);
  }

  if($('.template_customers_register').length){
    
    $(document).on('click', 'form#create_customer button[type="submit"]', function() {
      $('body,html').animate({scrollTop:0}, 500, 'swing');
      $('form#create_customer').attr('action','/pages/member_completed');
    });
  }

  
  if($('body[class*="template_collection_search"]').length ||
     $('.template_collection').length ||
     $('.template_search').length ||
     $('.template_collection_feature').length
    ){
    // 親要素を取得
    var moTarget = document.getElementsByClassName('boost-sd__filter-block')[0];
  
    // DOM操作時の動き
    function callback() {
      //処理
      $('.boost-sd__filter-option').each(function(){
        if($(this).find('.boost-sd__filter-option-label button').text().indexOf('カテゴリ') != -1){
           $(this).addClass('category');
          // if($('body[class*="template_collection_search"]').length){
          //   $(this).find('.boost-sd__filter-option-label button.boost-sd__filter-option-title').text('カテゴリ');
          // }
        }
        if($(this).find('.boost-sd__filter-option-label button').text().indexOf('キャラクター') != -1){
           $(this).addClass('character');
          // if($('body[class*="template_collection_search"]').length){
          //   $(this).find('.boost-sd__filter-option-label button.boost-sd__filter-option-title').text('キャラクター');
          // }
        }
        if($(this).find('.boost-sd__filter-option-label button').text().indexOf('イベント') != -1){
           $(this).addClass('event');
        }
        if($(this).find('.boost-sd__filter-option-label button').text().indexOf('価格 (¥)') != -1){
           $(this).addClass('price');
        }
        if($(this).find('.boost-sd__filter-option-label button').text().indexOf('モード') != -1){
           $(this).addClass('mode');
        }
        if($(this).find('.boost-sd__filter-option-label button').text().indexOf('在庫') != -1){
           $(this).addClass('stock');
        }
      });
      $('.boost-sd__filter-option-item-label').each(function(){
        var addclass = kanaToRoman($(this).text(), 'hepburn', { latin : 'hyphen' });
        $(this).addClass(addclass).addClass($(this).text().replace( '™', '_tm' ));
      });
      // if($('span[class*="boost-sd__filter-option-item-label 以上"]').length){
      //   $('span[class*="boost-sd__filter-option-item-label 以上"]').each(function(){
      //     var option_price = $(this).text().replace( '以上 ', '' );
      //     option_price = option_price.replace( option_price, option_price+' 以上' );
      //     $(this).text(option_price);
      //   });
      // }
    }
  
    // MutationObserver登録・処理
    var mo = new MutationObserver(callback); 
    
    // 監視のオプション
    const moOption = {
      childList: true, //対象ノードの子ノードに対する追加・削除を監視
      subtree: true  //対象ノードとその子孫ノードも監視
    };
     
    // 監視対象とオプションを指定して observe() メソッドを実行（監視を開始）
    mo.observe(moTarget, moOption);
  }
  if($('body[class*="template_collection_search"]').length ||
     $('.template_collection').length ||
     $('.template_collection_feature').length
    ){
    
    if($('body[class*="template_collection_search"]').length ){
      setTimeout(function() {
        if(window.innerWidth < 767 && $('.boost-sd__filter-tree-toggle-button').length){
          $('.boost-sd__filter-tree-toggle-button').click();
        }
  
  	}, 3000);
    }
    //ブレイクポイント変更時にリロード
    const breakpoint = window.matchMedia("(max-width:767px)");

    breakpoint.addEventListener("change", () => {
      window.location.reload();
    });

    $(document).on('click', '.boost-sd__filter-option-item', function() {
      var count    = 0;
      var end      = 100;  // 繰り返したい回数
      
      var scrollOffsetY = window.pageYOffset;
      var sccheck = $(this).offset().top;
      var sccheck_buck = scrollOffsetY - sccheck;
      window.scrollTo(0,scrollOffsetY);
      var id = setInterval(() => {
        // スクロール中に再度位置を取得
        var newPosition = $(this).offset().top + sccheck_buck;
        // 最初の位置と新しく取得した位置が異なる場合
        window.scrollTo(0,newPosition);
        
        count += 1;
        // 終了条件
        if (count == end) {
          // 終了
          count = 0;
          clearInterval(id);
        }
      }, 5); // 遅らせる時間（ミリ秒）
    });
  }
}, {once: true});


/**
 * ひらがなまたはカタカナからローマ字へ変換
 * @param {string} targetStr ローマ字へ変換する文字列（変換元の文字列）
 * @param {"hepburn"|"kunrei"} [type="hepburn"] ローマ字の種類
 * @param {Object} [options] その他各種オプション
 *                           {boolean} [options.bmp=true] ... "ん"（n）の次がb.m.pの場合にnからmへ変換するかどうか
 *                           {"latin"|"hyphen"} [options.longSound="latin"] ... 長音の表し方
 * @return {string} ローマ字へ変換された文字列を返す
 */
var kanaToRoman = function(targetStr, type, options) {
	/**
	 * 変換マップ
	 */
	var romanMap = {
		'あ' : 'a',
		'い' : 'i',
		'う' : 'u',
		'え' : 'e',
		'お' : 'o',
		'か' : 'ka',
		'き' : 'ki',
		'く' : 'ku',
		'け' : 'ke',
		'こ' : 'ko',
		'さ' : 'sa',
		'し' : { hepburn : 'shi', kunrei : 'si' },
		'す' : 'su',
		'せ' : 'se',
		'そ' : 'so',
		'た' : 'ta',
		'ち' : { hepburn : 'chi', kunrei : 'ti' },
		'つ' : { hepburn : 'tsu', kunrei : 'tu' },
		'て' : 'te',
		'と' : 'to',
		'な' : 'na',
		'に' : 'ni',
		'ぬ' : 'nu',
		'ね' : 'ne',
		'の' : 'no',
		'は' : 'ha',
		'ひ' : 'hi',
		'ふ' : { hepburn : 'fu', kunrei : 'hu' },
		'へ' : 'he',
		'ほ' : 'ho',
		'ま' : 'ma',
		'み' : 'mi',
		'む' : 'mu',
		'め' : 'me',
		'も' : 'mo',
		'や' : 'ya',
		'ゆ' : 'yu',
		'よ' : 'yo',
		'ら' : 'ra',
		'り' : 'ri',
		'る' : 'ru',
		'れ' : 're',
		'ろ' : 'ro',
		'わ' : 'wa',
		'ゐ' : 'wi',
		'ゑ' : 'we',
		'を' : { hepburn : 'o', kunrei : 'wo' },
		'ん' : 'n',
		'が' : 'ga',
		'ぎ' : 'gi',
		'ぐ' : 'gu',
		'げ' : 'ge',
		'ご' : 'go',
		'ざ' : 'za',
		'じ' : { hepburn : 'ji', kunrei : 'zi' },
		'ず' : 'zu',
		'ぜ' : 'ze',
		'ぞ' : 'zo',
		'だ' : 'da',
		'ぢ' : { hepburn : 'ji', kunrei : 'di' },
		'づ' : { hepburn : 'zu', kunrei : 'du' },
		'で' : 'de',
		'ど' : 'do',
		'ば' : 'ba',
		'び' : 'bi',
		'ぶ' : 'bu',
		'べ' : 'be',
		'ぼ' : 'bo',
		'ぱ' : 'pa',
		'ぴ' : 'pi',
		'ぷ' : 'pu',
		'ぺ' : 'pe',
		'ぽ' : 'po',
		'きゃ' : 'kya',
		'きぃ' : 'kyi',
		'きゅ' : 'kyu',
		'きぇ' : 'kye',
		'きょ' : 'kyo',
		'くぁ' : 'qa',
		'くぃ' : 'qi',
		'くぇ' : 'qe',
		'くぉ' : 'qo',
		'くゃ' : 'qya',
		'くゅ' : 'qyu',
		'くょ' : 'qyo',
		'しゃ' : { hepburn : 'sha', kunrei : 'sya' },
		'しぃ' : 'syi',
		'しゅ' : { hepburn : 'shu', kunrei : 'syu' },
		'しぇ' : 'sye',
		'しょ' : { hepburn : 'sho', kunrei : 'syo' },
		'ちゃ' : { hepburn : 'cha', kunrei : 'tya' },
		'ちぃ' : ['tyi'],
		'ちゅ' : { hepburn : 'chu', kunrei : 'tyu' },
		'ちぇ' : ['tye'],
		'ちょ' : { hepburn : 'cho', kunrei : 'tyo' },
		'てゃ' : 'tha',
		'てぃ' : 'thi',
		'てゅ' : 'thu',
		'てぇ' : 'the',
		'てょ' : 'tho',
		'ひゃ' : 'hya',
		'ひぃ' : 'hyi',
		'ひゅ' : 'hyu',
		'ひぇ' : 'hye',
		'ひょ' : 'hyo',
		'ふぁ' : 'fa',
		'ふぃ' : 'fi',
		'ふぇ' : 'fe',
		'ふぉ' : 'fo',
		'みゃ' : 'mya',
		'みぃ' : 'myi',
		'みゅ' : 'myu',
		'みぇ' : 'mye',
		'みょ' : 'myo',
		'ヴぁ' : 'va',
		'ヴぃ' : 'vi',
		'ヴぇ' : 've',
		'ヴぉ' : 'vo',
		'ぎゃ' : 'gya',
		'ぎぃ' : 'gyi',
		'ぎゅ' : 'gyu',
		'ぎぇ' : 'gye',
		'ぎょ' : 'gyo',
		'じゃ' : { hepburn : 'ja', kunrei : 'zya' },
		'じぃ' : 'zyi',
		'じゅ' : { hepburn : 'ju', kunrei : 'zyu' },
		'じぇ' : 'zye',
		'じょ' : { hepburn : 'jo', kunrei : 'zyo' },
		'ぢゃ' : { hepburn : 'dya', kunrei : 'zya' },
		'ぢぃ' : 'dyi',
		'ぢゅ' : { hepburn : 'dyu', kunrei : 'zya' },
		'ぢぇ' : 'dye',
		'ぢょ' : { hepburn : 'dyo', kunrei : 'zya' },
		'びゃ' : 'bya',
		'びぃ' : 'byi',
		'びゅ' : 'byu',
		'びぇ' : 'bye',
		'びょ' : 'byo',
		'ぴゃ' : 'pya',
		'ぴぃ' : 'pyi',
		'ぴゅ' : 'pyu',
		'ぴぇ' : 'pye',
		'ぴょ' : 'pyo',
		'ぁ' : 'xa',
		'ぃ' : 'xi',
		'ぅ' : 'xu',
		'ぇ' : 'xe',
		'ぉ' : 'xo',
		'ゃ' : 'xya',
		'ゅ' : 'xyu',
		'ょ' : 'xyo',
		'っ' : 'xtu',
		'ヴ' : 'vu',
		'ー' : '-',
		'、' : ', ',
		'，' : ', ',
		'。' : '.',
		'身' : 'mi',
		'着' : { hepburn : 'tsu', kunrei : 'tu' },
		'配' : 'kuba',
		'土' : 'mi',
		'産' : 'yage',
		'菓' : 'ka',
		'子' : { hepburn : 'shi', kunrei : 'si' },
		'食' : 'shoku',
		'品' : 'hin',
		'雑' : 'za',
		'貨' : 'ka',
		'小' : 'ko',
		'物' : 'mono'
	};

	/**
	 * 長音のラテン文字
	 */
	var latins = {
		hepburn : {
			'a' : 257,
			'i' : 299,
			'u' : 363,
			'e' : 275,
			'o' : 333
		},
		kunrei : {
			'a' : 226,
			'i' : 238,
			'u' : 251,
			'e' : 234,
			'o' : 244
		}
	};

	if (typeof targetStr !== 'string' && typeof targetStr !== 'number') {
		throw '変換する対象が文字列ではありません。';
	}

	if (typeof type !== 'string' || !type.match(/^(hepburn|kunrei)$/)) type = 'hepburn';

	if (!options) options = {};
	if (typeof options.kana !== 'string') options.kana = 'all';
	if (!options.kana.match(/^(all|hiragana|katakana)$/)) options.kana = 'all';
	if (typeof options.bmp !== 'boolean') options.bmp = true;
	if (typeof options.longSound !== 'string') options.longSound = 'latin';
	if (!options.longSound.match(/^(latin|hyphen)$/)) options.longSound = 'latin';

	var remStr = String(targetStr), result = '', slStr, roman, lastStr;

	/**
	 * 残りの文字列から1文字を切り抜く
	 * @return {string} 切り抜いた1つの文字列を返す
	 */
	var splice = function() {
		var oneChar = remStr.slice(0, 1);
		remStr = remStr.slice(1);
		return oneChar;
	};

	/**
	 * 残りの文字列の最初が小文字か判定
	 * @return {boolean} 小文字の場合はtrue、そうでない場合はfalseを返す
	 */
	var isSmallChar = function() {
		return !!remStr.slice(0, 1).match(/^[ぁぃぅぇぉゃゅょァィゥェォャュョ]$/);
	};

	/**
	 * カタカナからひらがなへ変換
	 * @param {string} kana 元とおなるカタカナ
	 * @return {string} ひらがなへ変換された文字列
	 */
	var toHiragana = function(kana) {
		return kana.replace(/[\u30a1-\u30f6]/g, function(match) {
			return String.fromCharCode(match.charCodeAt(0) - 0x60);
		});
	};

	/**
	 * ひらがなから対応するローマ字を取得
	 * @param {string} kana 元となるひらがな
	 * @return {string} 見つかった場合は対応するローマ字、見つからなかったら元のひらがなを返す
	 */
	var getRoman = function(kana) {
		var roman = romanMap[toHiragana(kana)];
		if (roman) {
			if (typeof roman === 'string') {
				return roman;
			} else if (type === 'hepburn') {
				return roman.hepburn;
			} else if (type === 'kunrei') {
				return roman.kunrei;
			}
		} else {
			return kana;
		}
	};

	while (remStr) {
		slStr = splice();

		if (slStr.match(/^(っ|ッ)$/)) {
			slStr = splice();
			if (isSmallChar()) slStr += splice();

			roman = getRoman(slStr);
			roman = (roman !== slStr ? roman.slice(0, 1) : '') + roman;
		} else {
			if (isSmallChar()) slStr += splice();

			roman = getRoman(slStr);
		}

		var nextRoman = kanaToRoman(remStr.slice(0, 1));
		if (roman === 'n') {
			if (nextRoman.match(/^[aiueo]$/)) {
				roman += type === 'hepburn' ? '-': '\'';
			} else if (options.bmp && nextRoman.match(/^[bmp]/) && type === 'hepburn') {
				roman = 'm';
			}
		} else if (roman === '-') {
			lastStr = result.match(/[aiueo]$/);
			if (lastStr && options.longSound === 'latin') {
				result = result.slice(0, -1);
				roman = String.fromCharCode(latins[type][lastStr[0]]);
			}
		}

		result += roman;
	}

	return result;
};